import React from 'react';
import { Container, Grid, Box } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';

import { HeaderWrapper } from 'components/DashboardLayout/styles';
import { WelcomeHeaderWrapper } from 'components/DashboardLayout/styles';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

export interface HeaderProps {
  WelcomeHeader: React.ReactNode;
  MenuItem: React.ReactNode;
  NotificationsBloc: React.ReactNode;
  HeaderImage: string;
  intl: IntlShape;
}

const Header = ({
  WelcomeHeader,
  MenuItem,
  NotificationsBloc,
  HeaderImage,
  ...otherprops
}: HeaderProps) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);

  return (
    <HeaderWrapper image={HeaderImage} reverse={reverse}>
      <Container maxWidth="lg">
        <Box paddingTop={15}>
          <Box marginBottom={4.75}>
            <Grid container>
              <Grid xs={12} sm={6} md={3} item>
                <WelcomeHeaderWrapper>{WelcomeHeader}</WelcomeHeaderWrapper>
              </Grid>
            </Grid>
          </Box>

          <Grid
            container
            spacing={2}
            justify="space-between"
            alignItems="flex-end"
          >
            <Grid xs={12} sm={6} md={4} item>
              <WelcomeHeaderWrapper>{MenuItem}</WelcomeHeaderWrapper>
            </Grid>

            <Grid xs={12} sm={4} item>
              {NotificationsBloc}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </HeaderWrapper>
  );
};

export default injectIntl(Header);
